import axios from "../api";
export const markSbcSetSolved = async (setId, solved) => {
    await axios.post("/mark-sbc-set-solved", { setId, solved });
};
//# sourceMappingURL=markSbcSetSolved.js.map